import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import API, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await API.post("/auth/reset-password", { token, password });
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Nuova password" subtitle="Scegli una nuova password per il tuo account.">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <div><Label>Nuova password</Label><Input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="mt-1" /></div>
        {error && <p data-testid="reset-error" className="text-sm text-[#C0392B]">{error}</p>}
        <Button type="submit" data-testid="reset-submit" disabled={loading || !token} className="w-full h-12 bg-[#FFD23F] hover:bg-[#F2C200] text-[#0F1230] rounded-full">
          {loading ? "Aggiornamento..." : "Aggiorna password"}
        </Button>
        <Link to="/login" className="text-[#141A3A] text-sm inline-block">Torna all'accesso</Link>
      </form>
    </AuthShell>
  );
}
